import { render, staticRenderFns } from "./saveConfirm.vue?vue&type=template&id=2cca5ddc&scoped=true&"
import script from "./saveConfirm.vue?vue&type=script&lang=ts&"
export * from "./saveConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cca5ddc",
  null
  
)

export default component.exports